import AppSettings from "@/settings/appSettings"
import axios, { AxiosInstance } from "axios";


/**
 *  Get api call
 */



const client: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
});


const clientComercial: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Comercial,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientComercialUpload: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_ComercialOdata,
    headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientContabilitate: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Contabilitate,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientContabilitateRest: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_ContabilitateRest,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});


const clientComercialOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_ComercialOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientDocumente: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Documente,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientDocumenteOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_DocumenteOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    }
});

const clientResurseUmane: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_ResurseUmane,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientResurseUmaneOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_ResurseUmaneOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    }
});

const clientAuth: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});
const clientAuthOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_AuthOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientRapoarte: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Rapoarte,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },

});

const clientFinanciar: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Financiar,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientFinanciarOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_FinanciarOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientStocareDocumente: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_StocareDocumente,
    headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientEdi: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Edi,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientPortalHR: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_PortalHR,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientPortalHROdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_PortalHROdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientPortalHRUpload: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_PortalHR,
    headers: {
        'Accept': 'application/json',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientMedical: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Medical,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientMedicalOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_MedicalOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientStocuri: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_Stocuri,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

const clientStocuriOdata: AxiosInstance = axios.create({
    baseURL: AppSettings.API_Url_StocuriOdata,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    },
});

// ===== Interceptor global 401: la expirarea/invalidarea JWT -> logout automat =====
const allClients: AxiosInstance[] = [
    client, clientComercial, clientComercialUpload, clientContabilitate, clientContabilitateRest,
    clientComercialOdata, clientDocumente, clientDocumenteOdata, clientResurseUmane, clientResurseUmaneOdata,
    clientAuth, clientAuthOdata, clientRapoarte, clientFinanciar, clientFinanciarOdata, clientStocareDocumente,
    clientEdi, clientPortalHR, clientPortalHROdata, clientPortalHRUpload, clientMedical, clientMedicalOdata,
    clientStocuri, clientStocuriOdata,
];

let sessionExpiredHandled = false;
allClients.forEach((c) => {
    c.interceptors.response.use(
        (response) => response,
        (error) => {
            const status = error?.response?.status;
            // logout automat DOAR daca aveam deja un token (sesiune expirata),
            // NU la 401-urile de la login (parola gresita etc.) unde nu exista token.
            const hadToken = !!localStorage.getItem("ERA_Jwt");
            if (status === 401 && hadToken && !sessionExpiredHandled) {
                sessionExpiredHandled = true;
                localStorage.removeItem("ERA_Jwt");
                localStorage.removeItem("ERA_Company");
                localStorage.removeItem("ERA_SuperAdminChoice");
                // du utilizatorul la login (App.vue afiseaza login cand nu e autentificat)
                window.location.assign("/");
            }
            return Promise.reject(error);
        }
    );
});

const ApiHeader = {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=utf-8',
        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
    }
}


export default {
    client,
    clientComercial,
    ApiHeader,
    clientDocumente,
    clientRapoarte,
    clientComercialOdata,
    clientAuth,
    clientContabilitate,
    clientContabilitateRest,
    clientDocumenteOdata,
    clientResurseUmane,
    clientResurseUmaneOdata,
    clientComercialUpload,
    clientAuthOdata,
    clientFinanciar,
    clientFinanciarOdata,
    clientStocareDocumente,
    clientEdi,
    clientPortalHR,
    clientPortalHROdata,
    clientPortalHRUpload,
    clientMedical,
    clientMedicalOdata,
    clientStocuri,
    clientStocuriOdata
}
